module.exports = __webpack_public_path__ + "static/media/footerAndroid.1e95f964.svg";